import React from 'react';
import { Switch, Tooltip, Typography } from 'antd';
import { filterHint } from './bankFilterUtils';
import { episodeToggleLabelOf } from './assetCardsUi';

const { Text } = Typography;

interface Props {
    on: boolean;
    onChange: (v: boolean) => void;
    shown: number;
    total: number;
    /** Có căn cứ để lọc không — false thì khoá công tắc và nói rõ vì sao (xem bankFilterUtils). */
    filterable: boolean;
    /** Khung bước Tài sản (UI-assettabs): nhãn rõ + kiểu bảng; không truyền ⇒ Bank cũ giữ nguyên. */
    board?: boolean;
}

/**
 * Công tắc "chỉ tập đang mở" dùng chung cho 4 màn Bank (260819).
 *
 * Luôn hiện số đang thấy trên tổng: bộ lọc giấu bớt dữ liệu, mà thứ giấu dữ liệu im lặng thì sớm muộn
 * cũng khiến ai đó tưởng mất đồ và đi gen lại cái đã có.
 */
const EpisodeOnlyFilter: React.FC<Props> = ({ on, onChange, shown, total, filterable, board }) => {
    const h = filterHint(shown, total, { on, filterable });
    if (board) {
        return (
            <Tooltip title={h.hint}>
                <span className={`ac-tg${h.enabled ? '' : ' off'}`} data-testid="ac-episode-toggle">
                    <Switch size="small" checked={on && filterable} disabled={!h.enabled} onChange={onChange} aria-label="Chỉ hiện của tập này" />
                    <span>{episodeToggleLabelOf({ on, filterable, shown, total })}</span>
                </span>
            </Tooltip>
        );
    }
    return (
        <Tooltip title={h.hint}>
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                <Switch size="small" checked={on && filterable} disabled={!h.enabled} onChange={onChange} />
                <Text style={{ fontSize: 12, color: h.enabled ? undefined : 'var(--sb-faint)' }}>{h.label}</Text>
            </span>
        </Tooltip>
    );
};

export default EpisodeOnlyFilter;
